<div class="ui-g">
  <div class="ui-g-12">
    <p-table
      #dt
      [value]="page.items"
      [totalRecords]="page.total"
      [lazy]="true"
      (onLazyLoad)="onGridLazyLoad($event)"
      [sortField]="filter.sortField"
      [sortOrder]="filter.sortOrder"
      [rows]="filter.rows"
      [first]="filter.first"
      [rowsPerPageOptions]="[5, 10, 20]"
      [pageLinks]="3"
      [rowStyleClass]="getRowStyle"
      [loading]="loading"
      [resizableColumns]="true"
      [responsive]="true"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="opened">Opened</th>
          <th pSortableColumn="closed">Closed</th>
          <th pSortableColumn="assigneeName">Assignee</th>
          <th pSortableColumn="vehicleReg">Vehicle</th>
          <th pSortableColumn="comment">Incident</th>
          <th pSortableColumn="closureReason">Closure Reason</th>
          <th>Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>
            <div [title]="getDateDescription(item.opened)">
              {{ getDateDescription(item.opened) }}
            </div>
          </td>
          <td>
            <div [title]="getDateDescription(item.closed)">
              {{ getDateDescription(item.closed) }}
            </div>
          </td>
          <td>
            <div [title]="item.assigneeName || 'Assign to me'">
              <ng-container *ngIf="!item.closed; else assigneeNameRaw">
                <ng-container
                  *ngIf="item.assigneeId; then assigneeAnchor; else assignToMeAnchor"
                ></ng-container>
                <ng-template #assigneeAnchor>
                  <a [routerLink]="[]" (click)="openAssigneeSelectionPanel($event, item)">{{
                    item.assigneeName
                  }}</a>
                </ng-template>
                <ng-template #assignToMeAnchor>
                  <a [routerLink]="[]" (click)="assignToMe(item)">Assign to me</a>
                </ng-template>
              </ng-container>
              <ng-template #assigneeNameRaw>{{ item.assigneeName }}</ng-template>
            </div>
          </td>
          <td>
            <div [title]="item.vehicleReg">
              {{ item.vehicleReg }}
            </div>
          </td>
          <td>
            <div pTooltip="{{ item.comment }}">
              {{ item.typeName || 'N/A' }}
            </div>
          </td>
          <td>
            <div
              *ngIf="item.closureReason"
              pTooltip="{{ item.closureNotes }}"
              tooltipPosition="left"
            >
              {{ item.closureReason.reason }}
            </div>
          </td>
          <td>
            <a
              class="close-incident"
              *ngIf="!item.closed && currentUserId == item.assigneeId"
              (click)="closeIncident(item)"
              >Close</a
            >
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- DATATABLES DEPRECATED ---
        <p-dataTabl #dt [value]="page.items" [totalRecords]="page.total"
                     [lazy]="true" (onLazyLoad)="onGridLazyLoad($event)"
                     [sortField]="filter.sortField" [sortOrder]="filter.sortOrder"
                     [rows]="filter.rows" [first]="filter.first"
                     [rowsPerPageOptions]="[5,10,20]" [pageLinks]="3" [rowStyleClass]="getRowStyle"
                     [loading]="loading" [resizableColumns]="true" [responsive]="true">

            <p-column field="opened" header="Opened" [sortable]="tru" [style]="{'width': '13%'}">
                <ng-template let-item="rowData" pTemplate="body">
                    <div [title]="getDateDescription(item.opened)">
                        {{getDateDescription(item.opened)}}
                    </div>
                </ng-template>
            </p-column>
            <p-column field="closed" header="Closed" [sortable]="tru" [style]="{'width': '13%'}">
                <ng-template let-item="rowData" pTemplate="body">
                    <div [title]="getDateDescription(item.closed)">
                        {{getDateDescription(item.closed)}}
                    </div>
                </ng-template>
            </p-column>
            <p-column field="assigneeName" header="Assignee" [sortable]="tru" [style]="{'width': '12%'}">
                <ng-template let-item="rowData" pTemplate="body">
                    <div [title]="item.assigneeName || 'Assign to me'">
                        <ng-container *ngIf="!item.closed; else assigneeNameRaw">
                            <ng-container *ngIf="item.assigneeId; then assigneeAnchor; else assignToMeAnchor"></ng-container>
                            <ng-template #assigneeAnchor>
                                <a [routerLink]="[]" (click)="openAssigneeSelectionPanel($event, item)">{{item.assigneeName}}</a>
                            </ng-template>
                            <ng-template #assignToMeAnchor>
                                <a [routerLink]="[]" (click)="assignToMe(item)">Assign to me</a>
                            </ng-template>
                        </ng-container>
                        <ng-template #assigneeNameRaw>{{item.assigneeName}}</ng-template>
                    </div>
                </ng-template>
            </p-column>
            <p-column field="vehicleReg" header="Vehicle" [sortable]="tru" [style]="{'width': '8%'}">
                <ng-template let-item="rowData" pTemplate="body">
                    <div [title]="item.vehicleReg">
                        {{item.vehicleReg}}
                    </div>
                </ng-template>
            </p-column>
            <p-column field="comment" header="Incident" [sortable]="tru" [style]="{'width': '30%'}">
                <ng-template let-item="rowData" pTemplate="body">
                    <div pTooltip="{{item.comment}}">
                        {{ item.typeName || 'N/A'}}
                    </div>
                </ng-template>
            </p-column>
            <p-column field="closureReason.reason" header="Closure Reason" [sortable]="tru" [style]="{'width': '24%'}">
                <ng-template let-item="rowData" pTemplate="body">
                    <div *ngIf="item.closureReason" pTooltip="{{item.closureNotes}}" tooltipPosition="left">
                        {{ item.closureReason.reason }}
                    </div>
                </ng-template>
            </p-column>
            <p-column header="Action" [sortable]="false" [style]="{'width': '5%'}">
                <ng-template let-item="rowData" pTemplate="body">
                    <a class="close-incident" *ngIf="!item.closed && currentUserId == item.assigneeId" (click)="closeIncident(item);">Close</a>
                </ng-template>
            </p-column>
        </p-dataTable>

        -->
  </div>
</div>
<div class="ui-g">
  <form
    class="ui-g-12 ui-md-12 ui-g-nopad incident-form-container"
    [formGroup]="raiseIncidentsForm"
    (ngSubmit)="raiseIncident()"
  >
    <div class="ui-g-12 ui-md-4">
      <p-dropdown
        placeholder="Type"
        formControlName="typeId"
        [options]="typeOpts"
        [autoDisplayFirst]="false"
        [autoWidth]="false"
        [style]="{ width: '100%' }"
      ></p-dropdown>
    </div>
    <div class="ui-g-12 ui-md-6">
      <input formControlName="comment" pInputText placeholder="Comment..." style="width: 100%" />
    </div>
    <div class="ui-g-12 ui-md-2">
      <button
        pButton
        class="btn-to-right"
        type="submit"
        label="Raise Incident"
        [disabled]="raiseIncidentsForm.invalid"
      ></button>
    </div>
  </form>
  <!--
    <div class="ui-g-12 ui-md-2">
        <button pButton class="btn-to-right" label="History" (click)="showHistory()"></button>
    </div>
    -->
</div>

<p-overlayPanel #assigneeSelectionPanel (onHide)="onAssigneeSelectionPanelHide()">
  <div class="ui-g">
    <div class="ui-g-12 align-center">
      <a [routerLink]="[]" (click)="confirmAssigneeSelection()">Assign to me</a>
    </div>
    <div class="ui-g-12 align-center">
      <a [routerLink]="[]" (click)="assigneeSelectionPanel.hide()">Cancel</a>
    </div>
  </div>
</p-overlayPanel>

<p-dialog
  header="Close Incident"
  [(visible)]="closeIncidentDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '450px', height: '250px' }"
>
  <form [formGroup]="closeIncidentForm">
    <div class="ui-g" style="position: relative; height: 180px">
      <div class="ui-g-12">
        <div class="ui-grid-col-4">
          <label>Reason</label>
        </div>
        <div class="ui-grid-col-8">
          <p-dropdown
            placeholder="Select closure reason..."
            formControlName="closureReasonId"
            [options]="closureReasons"
            [autoDisplayFirst]="false"
            [autoWidth]="false"
            [style]="{ width: '100%' }"
          ></p-dropdown>
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-grid-col-4">
          <label>Notes</label>
        </div>
        <div class="ui-grid-col-8">
          <textarea
            name="notes"
            pInputTextarea
            style="width: 100%"
            maxlength="1024"
            rows="4"
            formControlName="closureNotes"
          ></textarea>
        </div>
      </div>
      <div class="ui-g-12">
        <button
          type="button"
          pButton
          icon="fa fa-close"
          (click)="clearClosureVars()"
          label="Close"
          class="ui-button btn-to-right"
        ></button>
        <button
          type="button"
          pButton
          icon="fa fa-check"
          label="Ok"
          (click)="confirmCloseIncident()"
          class="ui-button btn-to-right green-btn"
        ></button>
      </div>
    </div>
  </form>
</p-dialog>
